import { render, staticRenderFns } from "./MyProtocol.vue?vue&type=template&id=9c059f6e&scoped=true"
import script from "./MyProtocol.vue?vue&type=script&lang=js"
export * from "./MyProtocol.vue?vue&type=script&lang=js"
import style0 from "./MyProtocol.vue?vue&type=style&index=0&id=9c059f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c059f6e",
  null
  
)

export default component.exports